import type { PriceInfo } from "epsm-api-types/ws";
import type { UTCTimestamp } from "lightweight-charts";

export function updateVolumeData(
	prices: PriceInfo[],
	upColor: string,
	downColor: string,
) {
	return prices.map((item) => ({
		time: item.time as UTCTimestamp,
		value: item.volume || 0,
		color: (item.close ?? 0) >= (item.open ?? 0) ? upColor : downColor,
	}));
}
